import { signIn, signUp } from '../supabase-client.js';
import { previewTripInvite, setPendingInviteToken } from '../trip-invites.js';
import { escapeHtml } from '../utils/dom.js';

function authErrorMessage(error) {
  const msg = error?.message ?? '';
  if (msg.includes('Invalid login credentials')) return 'Email o password non corretti.';
  if (msg.includes('Email not confirmed')) {
    return "Conferma la tua email, poi riapri il link dell'invito.";
  }
  if (msg.includes('User already registered')) {
    return 'Esiste già un account con questa email — usa Accedi.';
  }
  return msg || 'Operazione non riuscita. Riprova.';
}

export async function renderInviteAuth(container, token, onSuccess) {
  setPendingInviteToken(token);

  let preview = { ok: false };
  try {
    preview = await previewTripInvite(token);
  } catch {
    preview = { ok: false, reason: 'error' };
  }

  if (!preview?.ok) {
    container.innerHTML = `
      <main class="login-page">
        <div class="login-card">
          <h1 class="login-title">Invito non valido</h1>
          <p class="login-subtitle">Il link è scaduto, già usato o non esiste.</p>
          <a class="btn-primary" href="#/shelf">Vai al login</a>
        </div>
      </main>
    `;
    return;
  }

  if (preview.expired) {
    container.innerHTML = `
      <main class="login-page">
        <div class="login-card">
          <h1 class="login-title">Invito scaduto</h1>
          <p class="login-subtitle">Chiedi a chi ti ha invitato un nuovo link per <strong>${escapeHtml(preview.tripTitle)}</strong>.</p>
          <a class="btn-primary" href="#/shelf">Vai al login</a>
        </div>
      </main>
    `;
    return;
  }

  const email = preview.email ?? '';
  const tripTitle = preview.tripTitle ?? 'viaggio';

  container.innerHTML = `
    <main class="login-page">
      <div class="login-card login-card--invite">
        <h1 class="login-title">Unisciti al viaggio</h1>
        <p class="login-subtitle">Sei invitato a <strong>${escapeHtml(tripTitle)}</strong> come <strong>${escapeHtml(preview.displayName ?? 'viaggiatore')}</strong>.</p>
        <div class="invite-auth-tabs" role="tablist">
          <button type="button" class="invite-auth-tab invite-auth-tab--active" data-tab="signup" role="tab">Crea account</button>
          <button type="button" class="invite-auth-tab" data-tab="signin" role="tab">Ho già un account</button>
        </div>
        <form class="login-form" id="invite-auth-form" novalidate>
          <label class="field">
            <span class="field-label">Email</span>
            <input
              class="field-input"
              type="email"
              name="email"
              value="${escapeHtml(email)}"
              readonly
              aria-readonly="true"
            />
          </label>
          <label class="field">
            <span class="field-label">Password</span>
            <input
              class="field-input"
              type="password"
              name="password"
              autocomplete="new-password"
              required
              minlength="6"
              placeholder="Minimo 6 caratteri"
            />
          </label>
          <p class="login-error" id="invite-auth-error" role="alert" hidden></p>
          <button class="btn-primary login-submit" type="submit" data-mode="signup">Crea account e unisciti</button>
        </form>
      </div>
    </main>
  `;

  const form = container.querySelector('#invite-auth-form');
  const errorEl = container.querySelector('#invite-auth-error');
  const submitBtn = container.querySelector('.login-submit');
  const tabs = container.querySelectorAll('.invite-auth-tab');
  let mode = 'signup';

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      mode = tab.dataset.tab;
      tabs.forEach((t) => t.classList.toggle('invite-auth-tab--active', t === tab));
      submitBtn.textContent =
        mode === 'signup' ? 'Crea account e unisciti' : 'Accedi e unisciti';
      submitBtn.dataset.mode = mode;
      form.querySelector('[name="password"]').autocomplete =
        mode === 'signup' ? 'new-password' : 'current-password';
    });
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    errorEl.hidden = true;
    errorEl.textContent = '';

    const password = String(new FormData(form).get('password') ?? '');
    if (password.length < 6) {
      errorEl.textContent = 'La password deve avere almeno 6 caratteri.';
      errorEl.hidden = false;
      return;
    }

    submitBtn.disabled = true;
    const prevLabel = submitBtn.textContent;
    submitBtn.textContent = 'Attendere…';

    try {
      if (mode === 'signup') {
        await signUp(email, password);
      } else {
        await signIn(email, password);
      }
      onSuccess();
    } catch (error) {
      errorEl.textContent = authErrorMessage(error);
      errorEl.hidden = false;
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = prevLabel;
    }
  });
}
